var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsercalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D83F87;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,58.7h-21.3c-44.2,0-80,35.8-80,80v256c0,44.2,35.8,80,80,80l0,0h168c-7.4-14.6-8.4-31.6-2.8-46.9 c10-27.2,29.2-50,54.3-64.6c-32.4-34.2-31-88.2,3.2-120.7c31.4-29.8,80.1-31.4,113.3-3.7V138.7c0-44.2-35.8-80-80-80h-21.3v48 c0,8.8-7.2,16-16,16s-16-7.2-16-16v-48H160v48c0,8.8-7.2,16-16,16c-8.8,0-16-7.2-16-16V58.7z M128,314.7h106.7c8.8,0,16-7.2,16-16 s-7.2-16-16-16H128c-8.8,0-16,7.2-16,16S119.2,314.7,128,314.7z M128,229.3h66.1c8.8,0,16-7.2,16-16s-7.2-16-16-16H128 c-8.8,0-16,7.2-16,16S119.2,229.3,128,229.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 387.6,
    cy: 304,
    r: 64
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327,485.3l121.5-0.3c20.5-0.1,37-16.7,36.9-37.2c0-4.3-0.8-8.6-2.3-12.7c-14.4-40.3-52.6-67.2-95.4-67.2 c-42.8,0.1-81,26.9-95.7,67.1c-7.1,19.3,2.8,40.8,22.1,47.9C318.2,484.6,322.6,485.3,327,485.3z M128,58.7h32v-16 c0-8.8-7.2-16-16-16c-8.8,0-16,7.2-16,16V58.7z M309.3,58.7h32v-16c0-8.8-7.2-16-16-16s-16,7.2-16,16V58.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsercalender);
export default __webpack_public_path__ + "static/media/user calender.366af35ba00a1c869712fae6198fa0a9.svg";
export { ForwardRef as ReactComponent };